import {BaseCachedService} from './Core/BaseCachedService';

class SpeciesInvasivityService extends BaseCachedService {
    get Url() { return super.Url + "/speciesInvasivities"; }
    get ModelName() { return "Species Invasivity"; }
    get PrimaryKeyProperty() { return "speciesInvasivityId"; }
}

export const service = new SpeciesInvasivityService();

